import React, {useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {EventCreateStampContext} from '~/common/fabric/CreateDesign/components/Stamp/EventCreateStampContext';
import {CanvasStickers} from '~/common/canvas/CanvasStickers';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {selectEnvelopeStickers} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';

export const StickersCanvas = ({className}) => {
  const {setCanvas} = useContext(EventCreateStampContext);
  const envelopeStickers = useSelector(selectEnvelopeStickers);
  const dispatch = useDispatch();

  const onChangeHandler = (envelopeStickers) => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {
        envelopeStickers,
      },
    });
  };

  return (
    <div className={className}>
      <CanvasStickers
        configJson={envelopeStickers}
        onChange={onChangeHandler}
        setCanvas={setCanvas}
      />
    </div>
  );
};
